// src/beta/components/PhasePhotoGrid.tsx
import type { V1PhasePhotoGroup } from '@/beta/types/dossier';

interface Props {
  groups: V1PhasePhotoGroup[];
}

/** § 6.4 (8): Photo phases — grouped grid.
 *  Each phase gets an eyebrow sub-header + thumbnail grid. All <img> are lazy. */
export function PhasePhotoGrid({ groups }: Props) {
  const total = groups.reduce((sum, g) => sum + g.images.length, 0);
  if (total === 0) {
    return (
      <p style={{ color: 'var(--vm-stone)', fontSize: 13, fontFamily: 'var(--vm-font-body)' }}>
        No photos on file.
      </p>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--vm-s-4)' }}>
      {groups.map((g) => (
        <div key={g.phase}>
          <h3
            style={{
              fontFamily: 'var(--vm-font-heading)',
              fontSize: 11,
              letterSpacing: '0.3em',
              textTransform: 'uppercase',
              color: 'var(--vm-stone)',
              margin: 0,
              marginBottom: 'var(--vm-s-2)',
            }}
          >
            {g.phase} — {g.images.length}
          </h3>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
              gap: 'var(--vm-s-1)',
            }}
          >
            {g.images.map((img) => (
              <figure key={img.id} style={{ margin: 0 }}>
                <div style={{ aspectRatio: '4 / 3', background: '#000', overflow: 'hidden' }}>
                  <img
                    src={img.url}
                    alt={img.caption ?? ''}
                    loading="lazy"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                {img.caption && (
                  <figcaption
                    style={{
                      fontFamily: 'var(--vm-font-body)',
                      fontSize: 11,
                      color: 'var(--vm-stone)',
                      marginTop: 4,
                    }}
                  >
                    {img.caption}
                  </figcaption>
                )}
              </figure>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
